import type { Distribution } from "@memorang/types";
import type { FontSchemaType } from "../../font";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import {
	FreeContentBanner,
	type FreeContentBannerProps,
} from "../FreeContentBanner";
import type { Stat } from "../RowStats";
import ContentHero from "./ContentHero";
import TagsSectionList, { type SectionTag } from "./TagsSectionList";

interface Props {
	distribution: Distribution;
	donutProgressData?: { x: string; y: number }[];
	donutProgressColorScale?: string[];
	productTitle: string;
	productImage: string;
	stats?: Stat[];
	sectionTags: SectionTag[];
	handleClickListItem: (selectedTagId: number, locked?: boolean) => void;
	appFont?: FontSchemaType;
	freeContentBanner?: FreeContentBannerProps;
}
const StudyPackView = ({
	distribution,
	donutProgressData,
	donutProgressColorScale,
	productTitle,
	productImage,
	stats,
	sectionTags,
	handleClickListItem,
	appFont,
	freeContentBanner,
}: Props) => {
	const { isMobile } = useDevice();

	return (
		<>
			{isMobile && (productImage || stats?.length) ? (
				<ContentHero
					distribution={distribution}
					donutProgressData={donutProgressData}
					donutProgressColorScale={donutProgressColorScale}
					title={productTitle}
					stats={stats}
					image={productImage}
				/>
			) : null}
			{freeContentBanner ? (
				<Box marginTop={isMobile ? 0 : 24}>
					<FreeContentBanner {...freeContentBanner} />
				</Box>
			) : null}
			<TagsSectionList
				sectionTags={sectionTags}
				handleClickListItem={handleClickListItem}
				appFont={appFont}
			/>
		</>
	);
};

export default StudyPackView;
